import { callApi } from './config/callApi'

export const getNotification = async (id: number): Promise<any> => {
  return callApi({
    method: 'get',
    url: `/notifications/${id}`,
  })
}

export const getAllNotifications = async (): Promise<any> => {
  return callApi({
    method: 'get',
    url: '/notifications',
  })
}
